
import React from "react";
import { Suspense, lazy } from 'react';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "../Components/Dashboard/Dashboard";
import SessionTimeoutRedirect from "../Components/Common/SessionTimeoutRedirect";

// const Dashboard = lazy(() => import('../Components/Dashboard/Dashboard.jsx'));

const AuthDashbord = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Dashboard/> : <SessionTimeoutRedirect />;
}
export default AuthDashbord;


